module.exports = __webpack_public_path__ + "4330b99f729ea2dfb59700700b053efa.png";